var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDesignPhase(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_40004923_4302)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.97 7.2698C21.36 6.8798 21.36 6.2498 20.97 5.8598L18.14 3.0298C17.75 2.6398 17.12 2.6398 16.73 3.0298L12.24 7.5198L8.35 3.6298C7.57 2.8498 6.3 2.8498 5.52 3.6298L3.62 5.5298C2.84 6.3098 2.84 7.5798 3.62 8.3598L7.51 12.2498L3 16.7598V20.9998H7.24L11.76 16.4798L15.65 20.3698C16.6 21.3198 17.88 20.9698 18.48 20.3698L20.38 18.4698C21.16 17.6898 21.16 16.4198 20.38 15.6398L16.49 11.7498L20.97 7.2698ZM5.04 6.9398L6.93 5.0398L8.2 6.3098L7.02 7.4998L8.43 8.9098L9.62 7.7198L10.82 8.9198L8.92 10.8198L5.04 6.9398ZM16.27 14.3798L15.08 15.5698L16.49 16.9798L17.68 15.7898L18.95 17.0598L17.05 18.9598L13.16 15.0698L15.06 13.1698L16.27 14.3798ZM6.41 18.9998H5V17.5898L14.61 7.9798L15.91 9.2798L16.02 9.3898L6.41 18.9998ZM16.02 6.5598L17.43 5.1498L18.84 6.5598L17.43 7.9698L16.02 6.5598Z",
    fill: "#0094FB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_40004923_4302"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesignPhase);
export default __webpack_public_path__ + "static/media/DesignPhase.26dfaaaaf7aea06c52f8eedacc599a73.svg";
export { ForwardRef as ReactComponent };